import { Link } from "react-router-dom";
import { gossipCategories } from "@/mocks/gossipCategories";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  const [lead, ...rest] = gossipCategories;

  return (
    <section id="categories" className="scroll-mt-28 bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="Topics"
          title="主题分类"
          description="按你关心的方向订阅式浏览：想看圈内风向、明星行程、剧综口碑还是全网热点，都能直接进入对应栏目。"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <Link
            to={`/category/${lead.slug}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 sm:col-span-2 lg:row-span-1"
          >
            <div className="h-56 w-full overflow-hidden md:h-72">
              <img
                src={lead.cover}
                alt={`${lead.name} - 瓜料动态栏目`}
                title={`${lead.name} - 瓜料动态实时吃瓜`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-label text-background-50">
                <i className="ri-fire-line" /> 最热栏目
              </span>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">{lead.name}</h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-200">{lead.description}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-accent-300">
                进入栏目 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          {rest.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-36 w-full overflow-hidden">
                <img
                  src={category.cover}
                  alt={`${category.name} - 瓜料动态栏目`}
                  title={`${category.name} - 瓜料动态实时吃瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-label text-accent-800">
                    {category.tagline}
                  </span>
                </div>
                <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{category.description}</p>
                <span className="mt-auto pt-4 text-sm text-primary-600">
                  浏览 {category.name} <i className="ri-arrow-right-line align-middle" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}